import SprintList from '../components/sprint/SprintList';
import { useApp } from '../context/AppContext';
import TaskModal from '../components/task/TaskModal';

import { PageTitle } from '../../../../_metronic/layout/core';

export default function SprintsPage() {
  const { state, dispatch } = useApp();
  const selectedTask = state.tasks.find(t => t.id === state.selectedTaskId);

  return (
    <>
      <PageTitle>DevOps - Sprints</PageTitle>
      <SprintList />
      {selectedTask && (
        <TaskModal
          task={selectedTask}
          onClose={() => dispatch({ type: 'SELECT_TASK', payload: null })}
        />
      )}
    </>
  );
}
